import PromoView from "compid/shared/views/PromoView";
import React from "react";
import { ImageAsset } from "res";


export default function AutopayPromoView(props) {
  return (
    <div className="autopay-promo-view">
      <PromoView
        icon={<ImageAsset id="CompanyBillerImage" className="logo-icon" />}
        title="Let's simplify this process..."
        description="Add autopay so your bill is paid on time, every time."
        text="Add autopay"
        dataPoint="Add_Autopay"
        onClick={ props.onClick }
      />
    </div>
  );
}
